import { Fragment, useEffect } from "react";
import "react-tooltip/dist/react-tooltip.css";
import ChartNav from "../../../common/ChartNav";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Medications from "../../clinical-services/medications/medications";
import { setClinicalServiceName, setClinicalServiceSteps } from "../../../../redux/modules/clinical-services/actions";
import { useParams } from "react-router-dom";
import { fetchNotepad } from "../../../../redux/modules/patient/actions";
import MedicationDashboard from "./MedicationDashboard";

const PatientMedication = () => {
  const { patient } = useSelector((state) => state.patients);
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { id } = useParams();
  const dispatch = useDispatch();
  const [showMenu, setShowMenu] = useState(true);
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    dispatch(fetchNotepad(id));
    dispatch(setClinicalServiceName(null));
    dispatch(setClinicalServiceSteps(null));
  }, [clinicalServiceObj]);


  if (!patient) return null;

  return (
    <div className="relative flex flex-col flex-1 gap-4 bg-white pt-5">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <Medications showMedication={true} activeTab={activeTab} />
          <MedicationDashboard onActiveTabChange={setActiveTab} />
        </div>
      </div>
    </div>
  );
};

export default PatientMedication;
